import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";

export const addDiscountToRentByPromo = async (
    sessionKey,
    promocode,
    force = false
) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/add/discount/promocode`,
            method: "PUT",
            data: {
                promocode:
                    typeof promocode === "string"
                        ? promocode.trim()
                        : promocode,
                force,
            },
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
